/**
 * @file モーダルダイアログ
 * @namespace ddv2.library
 */

import message from '@/ddv2.library/messages'
import Swal from 'sweetalert2'

/**
 * @module modals
 */
export default {
  /**
   * 指定のメッセージでConfirmを表示する
   * @param {String} messageNo msysMessage.messageCd
   * @param {Array} args 埋め込み文字列
   * @returns {Promise<Boolean>}
   * @example
   * message.showConfirm('COMA0000').then((ok) => {})
   * or
   * message.showConfirm('COMA0000', ['A', 'B']).then((ok) => {})
   */
  showConfirm: function (messageNo, confrimTitle, confirmIcon, args) {
    const m = message.get(messageNo, args)
    return new Promise((resolve) => {
      Swal.fire({
        title: (confrimTitle) && confrimTitle != null && confrimTitle !== '' ? confrimTitle : '',
        html: m,
        icon: (confirmIcon) && confirmIcon != null && confirmIcon !== '' ? confirmIcon : 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        customClass: {
          confirmButton: 'sa-s-button',
          cancelButton: 'sa-s-button'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  },
  showConfirmYesNo: function (messageNo, confrimTitle, confirmIcon, args) {
    const m = message.get(messageNo, args)
    return new Promise((resolve) => {
      Swal.fire({
        showDenyButton: true,
        showCancelButton: false,
        title: (confrimTitle) && confrimTitle != null && confrimTitle !== '' ? confrimTitle : '',
        html: m,
        icon: (confirmIcon) && confirmIcon != null && confirmIcon !== '' ? confirmIcon : 'question',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'はい',
        denyButtonText: 'いいえ',
        customClass: {
          confirmButton: 'sa-s-button',
          denyButton: 'sa-s-button'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  },
  showConfirmYesNoCancel: function (messageNo, confrimTitle, confirmIcon, args) {
    const m = message.get(messageNo, args)
    return new Promise((resolve) => {
      Swal.fire({
        showDenyButton: true,
        showCancelButton: true,
        title: (confrimTitle) && confrimTitle != null && confrimTitle !== '' ? confrimTitle : '',
        html: m,
        icon: (confirmIcon) && confirmIcon != null && confirmIcon !== '' ? confirmIcon : 'question',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'はい',
        denyButtonText: 'いいえ',
        cancelButtonText: 'キャンセル',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 sa-s-button right-gap',
          confirmButton: 'order-2 sa-s-button',
          denyButton: 'order-3 sa-s-button'
        }
      }).then((result) => {
        resolve(result)
      })
    })
  },
  showConfirmYesNoCancelCustom: function (messageNo, confrimTitle, confirmIcon, args, confirmText, denyText) {
    const m = message.get(messageNo, args)
    return new Promise((resolve) => {
      Swal.fire({
        showDenyButton: true,
        showCancelButton: true,
        title: (confrimTitle) && confrimTitle != null && confrimTitle !== '' ? confrimTitle : '',
        html: m,
        icon: (confirmIcon) && confirmIcon != null && confirmIcon !== '' ? confirmIcon : 'question',
        confirmButtonColor: '#3085d6',
        confirmButtonText: (confirmText) && confirmText != null && confirmText !== '' ? confirmText : 'はい',
        denyButtonText: (denyText) && denyText != null && denyText !== '' ? denyText : 'いいえ',
        cancelButtonText: 'キャンセル',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 sa-s-button right-gap',
          confirmButton: 'order-2 sa-m-button',
          denyButton: 'order-3 sa-m-button'
        }
      }).then((result) => {
        resolve(result)
      })
    })
  },
  /**
   * 指定のメッセージでAlertを表示する
   * @param {String} messageNo msysMessage.messageCd
   * @param {Array} args 埋め込み文字列
   * @returns {Promise}
   * @example
   * message.showAlert('COMA0000').then(() => {})
   * or
   * message.showAlert('COMA0000', ['A', 'B']).then(() => {})
   */
  showAlert: function (messageNo, confrimTitle, confirmIcon, args) {
    const m = message.get(messageNo, args)
    return new Promise((resolve) => {
      Swal.fire({
        title: (confrimTitle) && confrimTitle != null && confrimTitle !== '' ? confrimTitle : '',
        html: m,
        icon: (confirmIcon) && confirmIcon != null && confirmIcon !== '' ? confirmIcon : 'info',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
      resolve()
    })
  },
  showAlertOk: function (messageNo, confrimTitle, confirmIcon, args) {
    const m = message.get(messageNo, args)
    return new Promise((resolve) => {
      Swal.fire({
        title: (confrimTitle) && confrimTitle != null && confrimTitle !== '' ? confrimTitle : '',
        html: m,
        icon: (confirmIcon) && confirmIcon != null && confirmIcon !== '' ? confirmIcon : 'info',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  },
  showAlertYesNo: function (messageNo, confrimTitle, confirmIcon, args) {
    const m = message.get(messageNo, args)
    return new Promise((resolve) => {
      Swal.fire({
        showDenyButton: true,
        showCancelButton: false,
        title: (confrimTitle) && confrimTitle != null && confrimTitle !== '' ? confrimTitle : '',
        html: m,
        icon: (confirmIcon) && confirmIcon != null && confirmIcon !== '' ? confirmIcon : 'info',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
        denyButtonText: 'NO'
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  },
  showAlertYesNoCancel: function (messageNo, confrimTitle, confirmIcon, args) {
    const m = message.get(messageNo, args)
    return new Promise((resolve) => {
      Swal.fire({
        showDenyButton: true,
        showCancelButton: true,
        title: (confrimTitle) && confrimTitle != null && confrimTitle !== '' ? confrimTitle : '',
        html: m,
        icon: (confirmIcon) && confirmIcon != null && confirmIcon !== '' ? confirmIcon : 'info',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
        denyButtonText: 'NO',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3'
        }
      }).then((result) => {
        resolve(result)
      })
    })
  },
  /**
   * 一定時間で消えるメッセージ
   * @param {*} msg
   */
  showToastMessage: function (messageNo, timer, width, position, icon, args) {
    const m = message.get(messageNo, args)
    const Toast = Swal.mixin({
      toast: true,
      showCloseButton: true,
      showConfirmButton: false,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
    Toast.fire({
      icon: (icon) && icon != null && icon !== '' ? icon : 'info',
      title: m,
      position: (position) && position != null && position !== '' ? position : 'top-end',
      timer: (timer) && timer != null && timer !== '' ? timer : 3000,
      width: (width) && width != null && width !== '' ? width : 300,
      customClass: {
        title: 'toast-message'
      }
    })
  },
  showToast: function (message, timer, width, position, icon) {
    const Toast = Swal.mixin({
      toast: true,
      showCloseButton: true,
      showConfirmButton: false,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
    Toast.fire({
      icon: (icon) && icon != null && icon !== '' ? icon : 'info',
      title: message,
      position: (position) && position != null && position !== '' ? position : 'top-end',
      timer: (timer) && timer != null && timer !== '' ? timer : 3000,
      width: (width) && width != null && width !== '' ? width : 300,
      customClass: {
        title: 'toast-message'
      }
    })
  },

  /*
   * 簡易メッセージ出力
   */
  // ダイアログメッセージ
  showError: function (msg) {
    return new Promise((resolve) => {
      Swal.fire({
        icon: 'error',
        html: msg
      }).then((result) => {
        resolve(result)
      })
    })
  },
  showSuccess: function (msg) {
    return new Promise((resolve) => {
      Swal.fire({
        icon: 'success',
        html: msg
      }).then((result) => {
        resolve(result)
      })
    })
  },
  showWarning: function (msg) {
    return new Promise((resolve) => {
      Swal.fire({
        icon: 'warning',
        html: msg
      }).then((result) => {
        resolve(result)
      })
    })
  }
}
